<script lang="ts">
    import { appState } from "../stores";
    import Notification from "../components/notification.svelte";

    let purging:boolean = false;
    let purger:ReturnType<typeof setTimeout>;
    $: if ($appState.notifications.length > 0) {
        if (!purging && $appState.notifications.length < 2) {
            purging = true;
            purger = setTimeout(() => {
                purging = false;
                if ($appState.notifications.length > 0) {  
                    $appState.notifications.shift();
                    $appState.notifications = $appState.notifications;
                }
            }, 3000);
        } else if ($appState.notifications.length > 1) {
            $appState.notifications.shift(); // auto deletes any notification beyond the most recent, effectively eliminates a queue from forming
            $appState.notifications = $appState.notifications;
            clearTimeout(purger);
            purging = true;
            purger = setTimeout(() => {
                purging = false;
                if ($appState.notifications.length > 0) {
                    $appState.notifications.shift();
                    $appState.notifications = $appState.notifications;
                }
            }, 3000);
        }
    }

</script>

{#each $appState.notifications as notification, id (notification.id)}
    <div class="notification-area">
        <Notification message={notification.message} />
    </div>
{/each}

<style>
    .notification-area {
        width: 300px;
        position: fixed;
        top: 0;
        margin-top: 1rem;
        z-index: 15;
        left: 50%;
        transform: translateX(-50%);
    }
</style>
